import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import {
  Icon,
  Intent,
  InputGroup,
  TextArea,
  Dialog,
  Button,
} from '@blueprintjs/core';
import Clearfix from 'components/elements/clearfix';
import { IconNames } from '@blueprintjs/icons';
import { createForm } from 'rc-form';
import moment from 'moment';
import styled from 'styled-components';
import Message from 'rc-message';

//* ------------------------ */

import { updateOne as updateOneCoso } from 'api/cosoApi';
import TagInput from 'components/elements/input-tag';
import IconRequired from 'components/elements/required-icon';
import NumericInput from 'components/elements/numeric-input';
import FacilitySelect from 'components/elements/select-facility';
import DateInput from 'components/elements/date-input';
import SelectTagInput from 'components/elements/input-tag/select-input-tag';
import { DATE_FORMAT, COLOR } from 'config';
import { convertDateFromSever as convertDate } from 'utils/fnUtil';
import PermitTypeSelect from 'components/elements/select-permit-type';
import { IS_ENTERPRISE } from 'config';
// import dynamicRoleHOC from 'hoc/dynamicRole';

const ErrorContainer = styled.div`
  margin-top: 5px;
  color: #5c7080;
  font-size: 12px;
  color: red;
`;

const LabelContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-end;
`;

const HeaderContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
`;
// @dynamicRoleHOC()
class FacilitypermitForm extends React.Component {
  static propTypes = {
    isEdit: PropTypes.bool,
    initialValue: PropTypes.object,
    slugBack: PropTypes.string,
    handelSubmit: PropTypes.func,
    // facility: PropTypes.shape({
    //   _id: PropTypes.string,
    //   FacilityNameFull: PropTypes.string
    // })
  };
  state = {
    isOpenNumberPermit: false,
    LicenseNumber: null,
  };

  setInitialValue(keyPath, defaultValue) {
    if (this.props.isEdit) {
      let value = _.result(this.props.initialValue, keyPath, defaultValue);
      if (!value) value = defaultValue;
      return value;
    }
    return defaultValue;
  }

  setSelInitialValue(keyPath, defaultValue, nameLabel) {
    if (this.props.isEdit) {
      let selItem = _.result(this.props.initialValue, keyPath);
      if (!selItem) return defaultValue;
      return {
        value: selItem._id,
        label: nameLabel ? selItem[nameLabel] : selItem.Name,
      };
    }
    return defaultValue;
  }

  submit = () => {
    this.props.form.validateFields((error, value) => {
      value.facility = _.get(value.facility, 'value');
      value.permitType = _.get(value.permitType, 'value');
      // console.log(value);
      if (error) return;
      if (this.props.handelSubmit) this.props.handelSubmit(value);
    });
  };

  renderInfoFacility = () => {
    let info = this.props.facility;

    return (
      <React.Fragment>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Địa chỉ</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup disabled value={_.get(info, 'Address1', '')} />
          </Col>
        </Row>
        <Clearfix height={8} />
        {!IS_ENTERPRISE && (
          <React.Fragment>
            <Row>
              <Col xs={4}>
                <LabelContainer>Nguồn tiếp nhận 2</LabelContainer>
              </Col>
              <Col xs={4}>
                <InputGroup
                  disabled
                  value={_.get(info, 'ReceviedSource_2.Name', '')}
                />
              </Col>
            </Row>
            <Clearfix height={8} />
            <Row>
              <Col xs={4}>
                <LabelContainer>Nguồn tiếp nhận 1</LabelContainer>
              </Col>
              <Col xs={4}>
                <InputGroup
                  disabled
                  value={_.get(info, 'ReceviedSource_1.Name', '')}
                />
              </Col>
            </Row>
            <Clearfix height={8} />
          </React.Fragment>
        )}
        <Row>
          <Col xs={4}>
            <LabelContainer>Vĩ độ (VN2000)</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup disabled value={_.get(info, 'LatitudeVN2000', '')} />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Kinh độ (VN2000)</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup disabled value={_.get(info, 'LongitudeVN2000', '')} />
          </Col>
        </Row>
      </React.Fragment>
    );
  };

  renderDialogNumberPermit = () => {
    const { resetFields } = this.props.form;
    let info = this.props.facility;
    let LicenseNumberLocal = [];
    return (
      <Dialog
        style={{ background: 'white' }}
        icon='info-sign'
        onClose={() => {
          console.log('close');
          this.setState({
            isOpenNumberPermit: false,
          });
        }}
        title={`${_.get(info, 'FacilityNameFull')}`}
        isOpen={this.state.isOpenNumberPermit}
      >
        <div style={{ padding: 8 }}>
          <Clearfix height={8} />
          <Row>
            <Col xs={3}>
              <LabelContainer>Số giấy phép</LabelContainer>
            </Col>
            <Col xs={6}>
              <TagInput
                LicenseNumberUsed={_.get(info, 'LicenseNumberUsed', [])}
                value={
                  this.state.LicenseNumber || _.get(info, 'LicenseNumber', [])
                }
                placeholder='Số giấy phép'
                onChange={(value) => {
                  LicenseNumberLocal = value;
                }}
              />
            </Col>
          </Row>
          <Clearfix height={8} />
          <Row>
            <Col>
              <Button
                onClick={async () => {
                  const res = await updateOneCoso(info._id, {
                    LicenseNumber: LicenseNumberLocal,
                  });
                  if (res.success && res.data) {
                    resetFields(['LicenseNumber']);
                    Message.success({
                      content: 'Cập nhật giấy phép thành công',
                    });
                    this.setState({
                      isOpenNumberPermit: false,
                      LicenseNumber: LicenseNumberLocal,
                    });
                  }
                  if (res.error) Message.error({ content: res.message });
                }}
                icon='saved'
                className='bp3-intent-success float-right'
                style={{
                  backgroundColor: COLOR.SUCCESS,
                  color: COLOR.TEXT_COLOR,
                }}
              >
                Lưu
              </Button>
            </Col>
          </Row>
        </div>
      </Dialog>
    );
  };

  render() {
    const { getFieldProps, getFieldError, getFieldValue } = this.props.form;

    return (
      <div>
        {this.renderDialogNumberPermit()}
        <h4
          className='bp3-heading'
          style={{
            color: COLOR.SUCCESS,
          }}
        >
          Chi tiết Giấy phép
        </h4>
        <Row>
          <Col xs={4}>
            <HeaderContainer>
              <Icon
                icon={IconNames.SAVED}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.PRIMARY}
                onClick={this.submit}
                style={{ color: COLOR.SUCCESS }}
              />
              <Clearfix width={8} />
              {/* <Link to={this.props.slugBack ? this.props.slugBack : slug.BASE}> */}
              <Icon
                onClick={() => {
                  window.history.back();
                }}
                icon={IconNames.DISABLE}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.DANGER}
              />
              {/* </Link> */}
            </HeaderContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Tên cơ sở/dự án
              <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <FacilitySelect
              isDisabled={this.props.facility ? true : false}
              hideLabel
              fieldForm={{
                form: this.props.form,
                name: 'facility',
                option: {
                  initialValue: this.props.facility
                    ? {
                        value: this.props.facility._id,
                        label: this.props.facility.FacilityNameFull,
                      }
                    : null,
                  rules: [
                    {
                      required: true,
                      message: 'Tên cơ sở/dự án is required',
                    },
                  ],
                },
              }}
            />
            <ErrorContainer>
              {(getFieldError('facility') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        {this.renderInfoFacility()}

        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Loại giấy phép <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <PermitTypeSelect
              hideLabel
              fieldForm={{
                form: this.props.form,
                name: 'permitType',
                option: {
                  initialValue: this.setSelInitialValue('permitType'),
                  rules: [
                    {
                      required: true,
                      message: 'Vui lòng chọn loại giấy phép',
                    },
                  ],
                },
              }}
            />
            <ErrorContainer>
              {(getFieldError('permitType') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Số giấy phép <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <SelectTagInput
              placeholder='Số giấy phép'
              dataSource={
                this.state.LicenseNumber ||
                _.get(this.props.facility, 'LicenseNumber', [])
              }
              {...getFieldProps('LicenseNumber', {
                initialValue: this.setInitialValue('LicenseNumber'),
                rules: [
                  {
                    required: true,
                    message: 'Vui lòng chọn số giấy phép',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('LicenseNumber') || []).join(', ')}
            </ErrorContainer>
          </Col>
          <div
            style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
            xs={1}
          >
            <Icon
              onClick={() => {
                this.setState({
                  isOpenNumberPermit: true,
                });
              }}
              icon={IconNames.ADD}
              iconSize={Icon.SIZE_LARGE}
              intent={Intent.SUCCESS}
              style={{ color: COLOR.SUCCESS }}
            />
          </div>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Tên giấy phép</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Tên giấy phép'
              {...getFieldProps('LicenseName', {
                initialValue: this.setInitialValue('LicenseName', ''),
              })}
            />
            <ErrorContainer>
              {(getFieldError('LicenseName') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Ngày cấp <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <DateInput
              formatDate={(date) => moment(date).format(DATE_FORMAT)}
              parseDate={(str) => moment(str).toDate()}
              placeholder='Ngày cấp'
              {...getFieldProps('IssueDate', {
                initialValue: convertDate(
                  this.setInitialValue('IssueDate', null)
                ),
                rules: [
                  {
                    required: true,
                    message: 'Vui lòng nhập ngày cấp',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('IssueDate') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Ngày hết hạn</LabelContainer>
          </Col>
          <Col xs={4}>
            <DateInput
              formatDate={(date) => moment(date).format(DATE_FORMAT)}
              parseDate={(str) => moment(str).toDate()}
              placeholder='Ngày hết hạn'
              {...getFieldProps('ExpiryDate', {
                initialValue: convertDate(
                  this.setInitialValue('ExpiryDate', null)
                ),
                rules: [
                  (rule, value, callback) => {
                    let IssueDate = getFieldValue('IssueDate');
                    if (value > IssueDate || !value) callback();
                    else
                      callback(new Error('Ngày hết hạn phải lớn hơn ngày cấp'));
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('ExpiryDate') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Thời hạn giấy phép (năm)</LabelContainer>
          </Col>
          <Col xs={4}>
            <NumericInput
              fill
              placeholder='Thời hạn giấy phép (năm)'
              {...getFieldProps('LicenseExpiry', {
                initialValue: this.setInitialValue('LicenseExpiry', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        {!IS_ENTERPRISE && (
          <React.Fragment>
            <Row>
              <Col xs={4}>
                <LabelContainer>Lưu lượng xả thải (m³/ngày.đêm)</LabelContainer>
              </Col>
              <Col xs={4}>
                <InputGroup
                  placeholder='Lưu lượng xả thải (m³/ngày.đêm)'
                  {...getFieldProps('DischargeFlow', {
                    initialValue: this.setInitialValue('DischargeFlow', ''),
                  })}
                />
              </Col>
            </Row>
            <Clearfix height={8} />
            <Row>
              <Col xs={4}>
                <LabelContainer>Quy chuẩn</LabelContainer>
              </Col>
              <Col xs={4}>
                <InputGroup
                  placeholder='Quy chuẩn'
                  {...getFieldProps('Standard', {
                    initialValue: this.setInitialValue('Standard', ''),
                  })}
                />
                <ErrorContainer>
                  {(getFieldError('Standard') || []).join(', ')}
                </ErrorContainer>
              </Col>
            </Row>
            <Clearfix height={8} />
          </React.Fragment>
        )}
        <Row>
          <Col xs={4}>
            <LabelContainer>Ghi chú</LabelContainer>
          </Col>
          <Col xs={4}>
            <TextArea
              fill
              {...getFieldProps('Notes', {
                initialValue: this.setInitialValue('Notes', null),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
      </div>
    );
  }
}

export default createForm()(FacilitypermitForm);



// WEBPACK FOOTER //
// ./src/containers/FacilitypermitContainer/FacilitypermitForm/index.js